import { render, staticRenderFns } from "./BeautifulForms.vue?vue&type=template&id=7a61a2d3&"
import script from "./BeautifulForms.vue?vue&type=script&lang=js&"
export * from "./BeautifulForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports